import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=61aa1f64&scoped=true"
import script from "./ClientsList.vue?vue&type=script&lang=js"
export * from "./ClientsList.vue?vue&type=script&lang=js"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=61aa1f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aa1f64",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Fclient%2Fclients-list%2FClientsList.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports